import SolutionRoutes from "@/packages/solutions/SolutionRoutes";
import SolutionStore from "@/packages/solutions/SolutionStore";

export default {
    install(Vue, options) {
        if (options.router) {
            options.router.addRoute(...SolutionRoutes)
        }
        if (options.store) {
            options.store.registerModule('Solution', SolutionStore)
        }
    }
}
